import React, { useState } from 'react';
import './style.css';
import { useForm, SubmitHandler } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Logo from "../assets/marca.png";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { api } from '../axiosInstance/axiosInstance';

const schema = z.object({
  newPassword: z.string().min(6, 'A senha deve ter pelo menos 6 caracteres'),
  confirmPassword: z.string().min(6, 'A confirmação de senha deve ter pelo menos 6 caracteres'),
}).refine(data => data.newPassword === data.confirmPassword, {
  message: 'As senhas devem corresponder',
  path: ['confirmPassword'],
});

type ResetPasswordFormValues = {
  newPassword: string;
  confirmPassword: string;
};

const ResetPasswordForm: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { email, verification_code } = location.state || {};

  const { register, handleSubmit, formState: { errors }, setError } = useForm<ResetPasswordFormValues>({
    defaultValues: {
      newPassword: "",
      confirmPassword: ""
    },
    resolver: zodResolver(schema),
  });

  const handleResetPassword: SubmitHandler<ResetPasswordFormValues> = async (data) => {
    try {
      setLoading(true);
      const response = await api.post('/reset-password', {
        newPassword: data.newPassword,
        email: email,
        verification_code: verification_code
      });
      setShowToast(true);
      setTimeout(() => {
        navigate("/login");
      }, 1800);
    } catch (error) {
      setError("confirmPassword", { message: "Ocorreu um erro ao alterar a senha" });
      setLoading(false);
    }
  };

  return (
    <html className="h-full gradient-background">
      <body className="dark:bg-slate-900 gradient-background flex items-start sm:items-center py-16 min-h-screen">
        <main className="w-full max-w-md mx-auto p-6">
          <div className="mt-7 bg-white border border-gray-200 rounded-xl shadow-sm dark:bg-gray-800 dark:border-gray-700">
            <div className="p-4 sm:p-7">
              <div className="text-center">
                <div className='w-full flex justify-center items-center '>
                  <img src={Logo} alt="logo-fonotherapp" className='h-8 w-8 rounded-full' />
                </div>
                <h1 className="block mt-2 text-2xl font-bold text-cyan-800 dark:text-white">
                  Redefinir Senha
                </h1>
                <Link className='underline text-cyan-600' to={"/confirmar-codigo"} >Voltar</Link>
              </div>

              <div className="mt-5">
                <hr className='mb-12' />
                <form onSubmit={handleSubmit(handleResetPassword)}>
                  <div className="grid gap-y-4">

                    <div>
                      <label className="block text-sm mb-2 dark:text-white">Nova Senha</label>
                      <div className="relative">
                        <input
                          {...register('newPassword')}
                          placeholder='Nova Senha'
                          type="password"
                          id="newPassword"
                          name="newPassword"
                          className={`py-3 border-2 outline-none px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-cyan-500 focus:ring-cyan-500 disabled:opacity-50 disabled:pointer-events-none ${errors.newPassword ? 'border-red-500' : ''}`}
                        />
                        {errors.newPassword && <p className="text-xs text-red-600 mt-2">{errors.newPassword.message}</p>}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm mb-2 dark:text-white">Confirmar Nova Senha</label>
                      <div className="relative">
                        <input
                          {...register('confirmPassword')}
                          placeholder='Confirmar Nova Senha'
                          type="password"
                          id="confirmPassword"
                          name="confirmPassword"
                          className={`py-3 border-2 outline-none px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-cyan-500 focus:ring-cyan-500 disabled:opacity-50 disabled:pointer-events-none ${errors.confirmPassword ? 'border-red-500' : ''}`}
                        />
                        {errors.confirmPassword && <p className="text-xs text-red-600 mt-2">{errors.confirmPassword.message}</p>}
                      </div>
                    </div>

                    <button type="submit" className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent  bg-primary text-white hover:bg-cyan-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600">
                      {loading ? <Spin style={{ color: "white" }} indicator={<LoadingOutlined spin />} size="default" />
                        : 'Redefinir'}
                    </button>
                  </div>
                </form>

                {showToast && (
                  <div className="text-center mt-4 text-green-600">
                    Senha Atualizada
                  </div>
                )}

              </div>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
};

export default ResetPasswordForm;
